let videoContainer = document.createElement("script");
let playButton = document.querySelector(".original-shark-tank__section .play-button");
let posterImage = document.querySelector(".original-shark-tank__section #video-poster__image");
videoContainer.src = "https://www.youtube.com/iframe_api";
videoContainer.dataset.original = "video-container";
let firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(videoContainer, firstScriptTag);

let player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player("video-container", {
    height: "604",
    width: "989",
    videoId: "NQ_2gIg18Ho",
    playerVars: {
      playsinline: 1,
      controls: 0,
      showinfo: 0,
      autohide: 1,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });

  new YT.Player("dtc-video-container", {
    videoId: "NQ_2gIg18Ho",
    playerVars: {
      playsinline: 1,
      controls: 0,
      showinfo: 0,
      autohide: 1,
    },
    events: {
      onReady: onDtcPlayerReady,
    },
  });
}

function onPlayerReady(event) {
  playButton.addEventListener("click", () => {
    setTimeout(() => {
      posterImage.style.display = "none";
      playButton.style.display = "none";
    }, 200);
    event.target.playVideo();
  });
}

function onDtcPlayerReady(event) {
  const videoThumb = document.querySelector('.dtc-video-thumbnail');
  const videoContainer = document.querySelector('#dtc-video-container');
  if (!!!videoThumb || !!!videoContainer) return;
  videoThumb.addEventListener('click', function() {
    setTimeout(() => {
      videoThumb.style.display = 'none';
      videoContainer.style.display = 'block';
    }, 200);
    event.target.playVideo(); // Play the video programmatically
  })
}

let done = false;
function onPlayerStateChange(event) {
  let sharkReviews = document.querySelectorAll(".original-shark-tank__section .shark-review__desktop");

  if (event.data == YT.PlayerState.PLAYING && !done) {
    sharkReviews.forEach((review) => {
      review.style.display = "none";
    });

    setTimeout(stopVideo, 6000);
    done = true;
  }
}
function stopVideo() {
  player.stopVideo();
}
